var _circle, _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongTermCaregiving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 15.618,
    cy: 3.594,
    r: 1.759
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M15.623 11.209v6.627M18.937 14.522h-6.628M15.618 31.836c0 4.189 3.302 7.585 7.375 7.585s7.341-2.331 7.375-7.585v-9.939a4.186 4.186 0 118.372 0v1.249"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M20.2 3.594h.335a3.816 3.816 0 013.818 3.818v14.324a3.816 3.816 0 01-3.818 3.818H10.7a3.807 3.807 0 01-3.807-3.818V7.412A3.807 3.807 0 0110.7 3.594h.335"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "IC_4L_main",
    x: 11.545,
    y: 25.576,
    width: 8.146,
    height: 5.14,
    rx: 1.559,
    ry: 1.559
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongTermCaregiving);
export default __webpack_public_path__ + "static/media/longTermCaregiving.b48482c672e8b051dbcaeb1c86164fe1.svg";
export { ForwardRef as ReactComponent };